import { Store } from '@tanstack/store';

type DrawerType = 'login' | 'register' | 'forgot_pass' | 'recover_pass' | null;

export const LoginDrawerStore = new Store<{ type: DrawerType }>({ type: null });
